import { BaseModel } from "../../utils/base-models/base-model";

export class User extends BaseModel {
    public id: string | null | undefined;
    public userCode: string | null | undefined;
    public userName: string | null | undefined;
    public fullName: string | null | undefined;
    public nickName: string | null | undefined;
    public phoneNumber: string | null | undefined;
    public email: string | null | undefined;
    public address: string | null | undefined;
    public pointType: number | null | undefined;
    public point: number | null | undefined;
    public doublePoint: number | null | undefined;
    public accumulatedPoint: number | null | undefined;
    public dateOfBirth: Date | null | undefined;
    public passwordHash: string | null | undefined;
    public confirmPassword: string | null | undefined;
    public gender: number | null | undefined;
    public shoesUse: string | null | undefined;
    public racketUse: string | null | undefined;
    public favoriteBall: string | null | undefined;
    public note: string | null | undefined;
    public guarantor: string | null | undefined;

    public isAdminAccount: boolean = false;
    public isActive: boolean = true;
    public userPhoto: string | null | undefined;
    public selected: boolean = false;


    get dateOfBirthStr() {
        if (this.dateOfBirth) {
            return new Date(this.dateOfBirth).toLocaleDateString('en-GB');
        }
        return '';
    }
    public static typeName = 'User';
    constructor(init?: Partial<User>) {
        super(User.typeName);
        Object.assign(this, init)
    }
}